import { ref, onMounted, nextTick } from 'vue'

const getDomEl = el => el?.$el ?? el ?? null

export const useElementSize = () => {
  const elRef = ref(null)
  const size = ref({
    width: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    x: 0,
    y: 0
  })

  const measureSize = async () => {
    await nextTick()
    const el = getDomEl(elRef.value)
    if (el) {
      const rect = el.getBoundingClientRect()
      size.value = {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
        x: rect.x,
        y: rect.y
      }
    }
  }

  onMounted(async () => {
    await nextTick()
    requestAnimationFrame(measureSize)
  })

  return { elRef, size, measureSize }
}
